"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thirtyPxMarginRight = exports.thirtyPxMarginBottom = exports.thirtyPxMarginTop = exports.tenPxMargin = exports.tenPxMarginTop = exports.tenPxMarginBottom = exports.tenPxMarginLeft = exports.tenPxMarginRight = exports.fivePxMarginRightLeft = exports.fivePxMarginBottom = exports.fivePxMarginTop = exports.fivePxMarginRight = exports.inlineBlock = void 0;

var _emotion = require("emotion");

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 30px;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 30px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 30px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 10px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin: 0px 5px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 5px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 5px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 5px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var inlineBlock = (0, _emotion.css)(_templateObject());
exports.inlineBlock = inlineBlock;
var fivePxMarginRight = (0, _emotion.css)(_templateObject2());
exports.fivePxMarginRight = fivePxMarginRight;
var fivePxMarginTop = (0, _emotion.css)(_templateObject3());
exports.fivePxMarginTop = fivePxMarginTop;
var fivePxMarginBottom = (0, _emotion.css)(_templateObject4());
exports.fivePxMarginBottom = fivePxMarginBottom;
var fivePxMarginRightLeft = (0, _emotion.css)(_templateObject5());
exports.fivePxMarginRightLeft = fivePxMarginRightLeft;
var tenPxMarginRight = (0, _emotion.css)(_templateObject6());
exports.tenPxMarginRight = tenPxMarginRight;
var tenPxMarginLeft = (0, _emotion.css)(_templateObject7());
exports.tenPxMarginLeft = tenPxMarginLeft;
var tenPxMarginBottom = (0, _emotion.css)(_templateObject8());
exports.tenPxMarginBottom = tenPxMarginBottom;
var tenPxMarginTop = (0, _emotion.css)(_templateObject9());
exports.tenPxMarginTop = tenPxMarginTop;
var tenPxMargin = (0, _emotion.css)(_templateObject10());
exports.tenPxMargin = tenPxMargin;
var thirtyPxMarginTop = (0, _emotion.css)(_templateObject11());
exports.thirtyPxMarginTop = thirtyPxMarginTop;
var thirtyPxMarginBottom = (0, _emotion.css)(_templateObject12());
exports.thirtyPxMarginBottom = thirtyPxMarginBottom;
var thirtyPxMarginRight = (0, _emotion.css)(_templateObject13());
exports.thirtyPxMarginRight = thirtyPxMarginRight;